<script lang="ts">
  import { Col, Image } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { Blogheader, Blogpara, Blogpara2 } from "../../../../utils/Constant/Constant";
  import CourseComment from "./CourseComment.svelte";
  let imgPath:string="/assets/images/faq"

</script>
<Col xl="9" class="xl-60 box-col-8">                        
  <div class="blog-single">
    <div class="blog-box blog-details">
      <div class="card">
        <Image fluid class="w-100" src="{imgPath}/learning-1.jpg" alt="blog-main" />
      </div>
      <Card>
        <div slot="contentbody">
          <div class="blog-details">
            <ul class="blog-social">
              <li class="digits">{'25 July 2018'}</li>
              <li>
                <i class="icofont icofont-user"></i>{'Mark'} 
                <span>{'Jecno'} </span>
              </li>
              <li class="digits">
                <i class="icofont icofont-thumbs-up"></i>{'02'}
                <span>{'Hits'}</span>
              </li>
              <li class="digits">
                <i class="icofont icofont-ui-chat"></i>{'598 Comments'}
              </li>
            </ul>
            <h4>{Blogheader}</h4>
            <div class="single-blog-content-top">
              <p>{Blogpara}</p>
              <p>{Blogpara2}</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <CourseComment />
  </div>
</Col>